export default __webpack_public_path__ + "img/producer-right.asset.01736096.jpeg";